import { useAPI } from 'hooks/api/useAPI';

import { NavRoute, DeployRoute } from 'application/types/routes';

import { Button } from 'components/Button/Button';

import { MarkdownEmbedProps } from 'services/markdown';
import { useHasAccess } from 'hooks/useHasAccess';

export function DeployButton(_props: MarkdownEmbedProps) {
  const { applicationID } = useAPI();
  const [hasAccess] = useHasAccess();

  return hasAccess('deploy_edit') ? (
    <div className="my-4">
      <Button
        to={`/applications/${applicationID}/${NavRoute.DEPLOY}/${DeployRoute.RAPID_DEPLOY}`}
        variant="secondary"
        size="small"
      >
        Deploy workflows
      </Button>
    </div>
  ) : null;
}
